/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListSkillsResult,
  ListSkillsResult$inboundSchema,
} from "../components/listskillsresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListSkillsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListSkillsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListSkillsSecurity = {
  option1?: ListSkillsSecurityOption1 | undefined;
  option2?: ListSkillsSecurityOption2 | undefined;
};

export const SourceKinds = {
  Manual: "manual",
  Captured: "captured",
} as const;
export type SourceKinds = ClosedEnum<typeof SourceKinds>;

export const Classifications = {
  Custom: "custom",
  BuiltIn: "built_in",
} as const;
export type Classifications = ClosedEnum<typeof Classifications>;

/**
 * How to order skills.
 */
export const ListSkillsQueryParamSort = {
  Name: "name",
  Updated: "updated",
} as const;
/**
 * How to order skills.
 */
export type ListSkillsQueryParamSort = ClosedEnum<
  typeof ListSkillsQueryParamSort
>;

export type ListSkillsRequest = {
  /**
   * Cursor for the next page of skills.
   */
  cursor?: string | undefined;
  /**
   * The number of skills to return per page.
   */
  limit?: number | undefined;
  /**
   * Search skill names, display names, and summaries.
   */
  search?: string | undefined;
  /**
   * Only return skills from these sources.
   */
  sourceKinds?: Array<SourceKinds> | undefined;
  /**
   * Only return skills with these classifications.
   */
  classifications?: Array<Classifications> | undefined;
  /**
   * Only return skills that have any of these tags.
   */
  tags?: Array<string> | undefined;
  /**
   * Only return skills at least one of these Speakeasy users is authorized to reach, through a grant on them or on a role they hold, less any blocking grant withdrawing the same scope. Plugin membership is distribution and does not widen it.
   */
  accessibleBy?: Array<string> | undefined;
  /**
   * How to order skills.
   */
  sort?: ListSkillsQueryParamSort | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListSkillsResponse = {
  result: ListSkillsResult;
};

/** @internal */
export type ListSkillsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListSkillsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListSkillsSecurityOption1$Outbound,
  ListSkillsSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listSkillsSecurityOption1ToJSON(
  listSkillsSecurityOption1: ListSkillsSecurityOption1,
): string {
  return JSON.stringify(
    ListSkillsSecurityOption1$outboundSchema.parse(listSkillsSecurityOption1),
  );
}

/** @internal */
export type ListSkillsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListSkillsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListSkillsSecurityOption2$Outbound,
  ListSkillsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listSkillsSecurityOption2ToJSON(
  listSkillsSecurityOption2: ListSkillsSecurityOption2,
): string {
  return JSON.stringify(
    ListSkillsSecurityOption2$outboundSchema.parse(listSkillsSecurityOption2),
  );
}

/** @internal */
export type ListSkillsSecurity$Outbound = {
  Option1?: ListSkillsSecurityOption1$Outbound | undefined;
  Option2?: ListSkillsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListSkillsSecurity$outboundSchema: z.ZodMiniType<
  ListSkillsSecurity$Outbound,
  ListSkillsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(z.lazy(() => ListSkillsSecurityOption1$outboundSchema)),
    option2: z.optional(z.lazy(() => ListSkillsSecurityOption2$outboundSchema)),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listSkillsSecurityToJSON(
  listSkillsSecurity: ListSkillsSecurity,
): string {
  return JSON.stringify(
    ListSkillsSecurity$outboundSchema.parse(listSkillsSecurity),
  );
}

/** @internal */
export const SourceKinds$outboundSchema: z.ZodMiniEnum<typeof SourceKinds> = z
  .enum(SourceKinds);

/** @internal */
export const Classifications$outboundSchema: z.ZodMiniEnum<
  typeof Classifications
> = z.enum(Classifications);

/** @internal */
export const ListSkillsQueryParamSort$outboundSchema: z.ZodMiniEnum<
  typeof ListSkillsQueryParamSort
> = z.enum(ListSkillsQueryParamSort);

/** @internal */
export type ListSkillsRequest$Outbound = {
  cursor?: string | undefined;
  limit: number;
  search?: string | undefined;
  source_kinds?: Array<string> | undefined;
  classifications?: Array<string> | undefined;
  tags?: Array<string> | undefined;
  accessible_by?: Array<string> | undefined;
  sort: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListSkillsRequest$outboundSchema: z.ZodMiniType<
  ListSkillsRequest$Outbound,
  ListSkillsRequest
> = z.pipe(
  z.object({
    cursor: z.optional(z.string()),
    limit: z._default(z.int(), 50),
    search: z.optional(z.string()),
    sourceKinds: z.optional(z.array(SourceKinds$outboundSchema)),
    classifications: z.optional(z.array(Classifications$outboundSchema)),
    tags: z.optional(z.array(z.string())),
    accessibleBy: z.optional(z.array(z.string())),
    sort: z._default(ListSkillsQueryParamSort$outboundSchema, "name"),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sourceKinds: "source_kinds",
      accessibleBy: "accessible_by",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listSkillsRequestToJSON(
  listSkillsRequest: ListSkillsRequest,
): string {
  return JSON.stringify(
    ListSkillsRequest$outboundSchema.parse(listSkillsRequest),
  );
}

/** @internal */
export const ListSkillsResponse$inboundSchema: z.ZodMiniType<
  ListSkillsResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListSkillsResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listSkillsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListSkillsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSkillsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSkillsResponse' from JSON`,
  );
}
